var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCsvIcon2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 36,
  height: 41,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#CSVIcon_2_svg__a)",
  d: "M32.25 1.333H3.75C1.679 1.333 0 2.843 0 4.705v32.368c0 1.862 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.372V4.705c0-1.862-1.679-3.372-3.75-3.372Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.2,
  d: "M32.25 1.333H3.75C1.679 1.333 0 2.843 0 4.705v32.368c0 1.862 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.372V4.705c0-1.862-1.679-3.372-3.75-3.372Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#CSVIcon_2_svg__b)",
  d: "M32.25 0H3.75C1.679 0 0 1.51 0 3.372v32.367c0 1.863 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.371V3.371C36 1.51 34.321 0 32.25 0Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#CSVIcon_2_svg__c)",
  d: "M32.25 0H3.75C1.679 0 0 1.51 0 3.372v32.367c0 1.863 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.371V3.371C36 1.51 34.321 0 32.25 0Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "M32.25 0H3.75C1.679 0 0 1.51 0 3.372v32.367c0 1.863 1.679 3.372 3.75 3.372h28.5c2.071 0 3.75-1.51 3.75-3.371V3.371C36 1.51 34.321 0 32.25 0Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M12.375 26.889c0 .351.273.625.625.625h10a.642.642 0 0 0 .625-.625v-11.25H20.5c-.703 0-1.25-.547-1.25-1.25v-3.125H13a.642.642 0 0 0-.625.625v15ZM13 9.389h6.445c.664 0 1.29.273 1.758.742l3.555 3.554c.469.47.742 1.094.742 1.758V26.89c0 1.406-1.133 2.5-2.5 2.5H13a2.468 2.468 0 0 1-2.5-2.5v-15c0-1.367 1.094-2.5 2.5-2.5Zm4.375 10h-2.5v1.875h2.5v-1.875Zm-2.5 3.125v1.875h2.5v-1.875h-2.5Zm3.75 0v1.875h2.5v-1.875h-2.5ZM18 25.639h-3.125c-.703 0-1.25-.547-1.25-1.25v-5c0-.664.547-1.25 1.25-1.25h6.25c.664 0 1.25.586 1.25 1.25v5c0 .703-.586 1.25-1.25 1.25H18Zm.625-4.375h2.5v-1.875h-2.5v1.875Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "CSVIcon_2_svg__a",
  x1: 0,
  x2: 36,
  y1: 20.889,
  y2: 20.889,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#147F2C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B700"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CSVIcon_2_svg__b",
  x1: 0,
  x2: 36,
  y1: 19.556,
  y2: 19.556,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B31217"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F3017E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "CSVIcon_2_svg__c",
  x1: 0,
  x2: 36,
  y1: 19.556,
  y2: 19.556,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#147F2C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B3B700"
})))));
export { SvgCsvIcon2 as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiMjc0OTA3ODFlYmFkZDA3Y2M1OWIwYzQxOWNkOTRkNmQuc3ZnIjs=";